import React, { useEffect, useState, useRef } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { Modal, ModalContent, ModalBody } from "@heroui/react";
import { useTranslation } from "react-i18next";
import videoProcessingAI from "../../../processing.mp4";

const CheckProductModal = ({
  isOpen,
  onClose,
  orderId,
  newSelectedCustomer,
  redirect = false,
}) => {
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState(false);
  const intervalIdRef = useRef(null);

  useEffect(() => {
    const reprocessOrder = async () => {
      setLoading(true);
      try {
        const response = await axiosPrivate.get(
          `/orders/${orderId}/reprocess?reprocessing_step=check_products_by_customers&customer_id=${newSelectedCustomer}`
        );
        if (response.status === 200) {
          startStatusCheck();
        } else {
          setLoading(false);
          window.location.reload();
          onClose();
        }
      } catch (error) {
        console.error(t("error_reprocessing_order"), error);
        startStatusCheck();
      }
    };

    const checkOrderStatus = async () => {
      try {
        const response = await axiosPrivate.get(`/orders/${orderId}`);
        if (response.status === 200 && response.data.process.status !== "active") {
          clearInterval(intervalIdRef.current);
          setLoading(false);
          window.location.reload();
          onClose();
        }
      } catch (error) {
        console.error(t("error_checking_order_status"), error);
      }
    };

    const startStatusCheck = () => {
      if (!intervalIdRef.current) {
        const id = setInterval(checkOrderStatus, 10000);
        intervalIdRef.current = id;
      }
    };

    if (isOpen) {
      reprocessOrder();
      return;
    }
    
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  }, [isOpen, axiosPrivate, orderId, onClose, newSelectedCustomer, t]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      placement="top-center"
      size="2xl"
      classNames={{
        backdrop:
          "bg-gradient-to-t from-vistadark/80 to-vistadark/60 backdrop-opacity-20",
      }}
    >
      <ModalContent>
        <ModalBody>
          {loading && (
            <div className="flex justify-center items-center p-8">
              <div className="w-80 text-center">
                <video src={videoProcessingAI} autoPlay loop />
              </div>
              <div className="ml-4 text-center text-sm text-vistagrey/70">
                {t("checking_products_for_new_customer")}
              </div>
            </div>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CheckProductModal;